function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

import React, { Component } from 'react';

var FullscreenExpandCloseButton = /*#__PURE__*/function (_Component) {
  _inheritsLoose(FullscreenExpandCloseButton, _Component);

  function FullscreenExpandCloseButton() {
    return _Component.apply(this, arguments) || this;
  }

  var _proto = FullscreenExpandCloseButton.prototype;

  _proto.closeButtonCreated = function closeButtonCreated(buttonElement) {
    this.closeButton = buttonElement;
  };

  _proto.componentDidMount = function componentDidMount() {
    if (this.closeButton && this.props.shoudAutofocus) {
      this.closeButton.focus && this.closeButton.focus();
    }
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    if (this.props.shouldRefocusOnCloseXButton && !prevProps.shouldRefocusOnCloseXButton) {
      this.focusOnCloseXButton();
    }
  };

  _proto.focusOnCloseXButton = function focusOnCloseXButton() {
    if (this.closeButton) {
      this.closeButton.focus && this.closeButton.focus();
    }
  };

  _proto.render = function render() {
    var _this = this;

    var url = this.props.homeGalleryPageUrl; // can be null and then will render <a> with no link; petri itemDeepLinks

    return /*#__PURE__*/React.createElement("a", {
      href: url,
      "data-cancel-link": "true"
    }, /*#__PURE__*/React.createElement("button", {
      className: "fullscreen-icon fullscreen-close " + this.props.iconClass,
      onClick: function onClick() {
        return _this.props.onClick();
      },
      tabIndex: this.props.tabIndex,
      "aria-label": this.props.title,
      ref: function ref(button) {
        return _this.closeButtonCreated(button);
      }
    }));
  };

  return FullscreenExpandCloseButton;
}(Component);

export default FullscreenExpandCloseButton;